module.exports = __webpack_public_path__ + "assets/gaizhui.a95ad553.svg";